import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class StripeService {

    private stripe_url = environment.stripe_url;
    constructor(private http: HttpClient) { }

    createPaymentLink(usdPrice: number, walletAddress: string) {
        return this.http.post<{ data: any }>(this.stripe_url, {
            usdPrice: usdPrice,
            walletAddress: walletAddress,
            domain: environment.stripe_domain
        })
    }

    verifyingPayment(session_id: string) {
        return this.http.post<{ data: any }>(this.stripe_url, {
            session_id,
            transation_type: "payment-verify"
        })
    }
}
